import { useEffect, type JSX } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box, Center, Loader, Stack, Text, Button, Group } from '@mantine/core';

export function JoinRedirect(): JSX.Element {
  const { threadId: paramThreadId } = useParams();
  const [searchParams] = useSearchParams();
  const queryThreadId = searchParams.get('id') || searchParams.get('thread') || searchParams.get('threadId');
  
  const threadId = paramThreadId || queryThreadId;

  useEffect(() => {
    if (threadId) {
      const deepLink = `feelheard://join/${threadId}`;
      console.log('Redirecting to:', deepLink);
      
      // Try to open the app
      window.location.href = deepLink;
      
      // Set up fallback to app stores
      const timer = setTimeout(() => {
        if (document.hasFocus()) {
          // App didn't open, redirect to app store
          const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
          const isAndroid = /Android/i.test(navigator.userAgent);
          
          if (isIOS) {
            window.location.href = 'https://apps.apple.com/app/id6746776325';
          } else if (isAndroid) {
            window.location.href = 'https://play.google.com/store/apps/details?id=me.feelheard';
          }
        }
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, [threadId]);

  return (
    <Center style={{ minHeight: '100vh', backgroundColor: '#0F172A' }}>
      <Stack align="center" gap="xl">
        <Loader size="lg" color="violet" />
        
        <Stack align="center" gap="md">
          <Text size="xl" fw={600} c="white">Opening FeelHeard...</Text>
          <Text size="md" c="dimmed">
            {threadId ? 'Redirecting you to the conversation...' : 'Invalid invitation link'}
          </Text>
        </Stack>

        {threadId && (
          <Button
            component="a"
            href={`feelheard://join/${threadId}`}
            variant="gradient"
            gradient={{ from: 'violet', to: 'grape' }}
            size="lg"
          >
            Open in FeelHeard
          </Button>
        )}

        <Group gap="xs">
          <Text size="sm" c="dimmed">Don't have the app?</Text>
        </Group>
        
        <Group gap="md">
          <Button
            component="a"
            href="https://apps.apple.com/app/id6746776325"
            variant="subtle"
            size="sm"
          >
            Download for iOS
          </Button>
          <Button
            component="a"
            href="https://play.google.com/store/apps/details?id=me.feelheard"
            variant="subtle"
            size="sm"
          >
            Download for Android
          </Button>
        </Group>
      </Stack>
    </Center>
  );
}